import { NgModule } from "@angular/core";
import { AngularFireAuthGuard, redirectLoggedInTo, redirectUnauthorizedTo } from "@angular/fire/compat/auth-guard";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "src/app/guard/auth.guard";
import { CharityPageComponent } from "./components/charity-page/charity-page.component";
import { ForgotPasswordPage } from "./components/forgot-password/forgot-password.page";
import { HoldingScreenComponent } from "./components/holding-screen/holding-screen.component";
import { LoginPage } from "./components/login/login.page";
import { PartnerOfferComponent } from "./components/partner-offer/partner-offer.component";
import { TyvisoOffersComponent } from "./components/tyviso-offers/tyviso-offers.component";
import { SuccessfulPaymentComponent } from "./components/payments/successful-payment/successful-payment.component";
import { ProsubPageComponent } from "./components/prosub-page/prosub-page.component";
import { QuickLaunchComponent } from "./components/quick-launch/quick-launch.component";
import { ReferFriendComponent } from "./components/refer-friend/refer-friend.component";
import { SetupCompleteComponent } from "./components/setup-complete/setup-complete.component";
import { SignupPage } from "./components/signup/signup.page";
import { SovendusPageComponent } from "./components/sovendus-page/sovendus-page.component";
import { SplashComponent } from "./components/splash/splash.component";
import { TakeoverPageComponent } from "./components/takeover-page/takeover-page.component";
import { TesterEventsComponent } from "./components/tester-events/tester-events.component";
import { VoucherRedeemComponent } from "./components/voucher-redeem/voucher-redeem.component";
import { VouchersComponent } from "./components/vouchers/vouchers.component";
import { CustomPreloadingStrategy } from "./custom-preloading-strategy";
import { salesGuard } from "./guard/sales.guard";
import { CloseConfirmationComponent } from "./pages/account/close-confirmation/close-confirmation.component";
import { DeleteConfirmationComponent } from "./pages/account/delete-confirmation/delete-confirmation.component";
import { ReqDataComponent } from "./pages/account/request-data/request-data.component";
import { SubscriptionSettingsComponent } from "./pages/account/subscription-settings/subscription-settings.component";
import { Easter } from "./pages/events/easter/easter";
import { Halloween } from "./pages/events/halloween/halloween";
import { SuperDraw } from "./pages/events/superdraw/superdraw";
import { Valentine } from "./pages/events/valentine/valentine";
import { AccountCreatedComponent } from "./pages/sales/account-created/account-created.component";
import { PreAuthpageComponent } from "./pages/sales/pre-authpage/pre-authpage.component";
import { SliderManagerComponent } from "./pages/slider-manager/slider-manager.component";
import { PickOfferComponent } from "./pages/store/pick-an-offer/pick-an-offer.component";
import { RedirectUriComponent } from "./pages/store/redirect-uri/redirect-uri.component";
import { SuggestionComponent } from "./components/suggestion/suggestion.component";
import { SurveyReturnComponent } from "./components/survey-return/survey-return.component";
import { OfflineWaitingComponent } from "./components/offline-waiting/offline-waiting.component";
import { RegisterPendingComponent } from "./pages/sales/register-pending/register-pending.component";
import { CampaignGuard } from "./guard/campaign.guard";
import { PublicOnlyGuard } from "./guard/public-only.guard";
import { ChristmasEvent } from "./pages/christmas-event/christmas-event";
const redirectUnauthorizedToWelcome = () => redirectUnauthorizedTo(["welcome"]);
const redirectLoggedInToHome = () => redirectLoggedInTo(["mainTabs", "tabs", "home"]);
const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(["login"]);
const routes: Routes = [
  {
    path: "",
    component: SplashComponent,
    canActivate: navigator.onLine ? [AngularFireAuthGuard as any] : ([] as AngularFireAuthGuard[]),
    data: {
      authGuardPipe: redirectUnauthorizedToWelcome,
    },
  },
  {
    path: "login",
    component: LoginPage,
    canActivate: [PublicOnlyGuard],
  },
  {
    path: "refer-friends",
    component: ReferFriendComponent,
    canActivate: [AngularFireAuthGuard, AuthGuard],
    data: {
      authGuardPipe: redirectUnauthorizedToLogin,
    },
  },
  {
    path: "signup",
    component: SignupPage,
    canActivate: [PublicOnlyGuard],
  },
  {
    path: "forgot-password",
    component: ForgotPasswordPage,
    canActivate: [AngularFireAuthGuard],
    data: {
      authGuardPipe: redirectLoggedInToHome,
    },
  },

  {
    path: "events",
    component: TesterEventsComponent,
    canActivate: [AngularFireAuthGuard],
  },
  // {
  //   path: "games-new",
  //   component: GamesFeedSampleComponent,
  //   canActivate: [AngularFireAuthGuard],
  // },
  {
    path: "mainTabs",
    loadChildren: () => import("./pages/tabs/tabs.module").then((m) => m.TabsPageModule),
  },
  {
    path: "home",
    redirectTo: "mainTabs/tabs/home",
    pathMatch: "full",
  },
  {
    path: "sovendus-offers",
    component: SovendusPageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "tyviso-offers",
    component: TyvisoOffersComponent,
    canActivate: [AngularFireAuthGuard, AuthGuard],
    data: {
      authGuardPipe: redirectUnauthorizedToLogin,
    },
  },
  {
    path: "event/christmas",
    component: ChristmasEvent,
  },
  {
    path: "event/valentine",
    component: Valentine,
  },
  {
    path: "event/easter",
    component: Easter,
  },
  {
    path: "event/superdraw",
    component: SuperDraw,
  },
  {
    path: "event/halloween",
    component: Halloween,
  },
  {
    path: "home",
    loadChildren: () => import("./pages/home/home.module").then((m) => m.HomePageModule),
    data: { preload: true, delay: true, priority: 0 },
  },
  {
    path: "syndicate",
    redirectTo: "mainTabs/tabs/syndicate",
    pathMatch: "full",
  },
  {
    path: "syndicate",
    loadChildren: () => import("./pages/syndicate/syndicate.module").then((m) => m.SyndicatePageModule),
    data: { preload: true, delay: true, priority: 1 },
  },
  {
    path: "games-old",
    redirectTo: "mainTabs/tabs/game-old",
    pathMatch: "full",
  },
  {
    path: "games-old",
    loadChildren: () => import("./pages/games/games.module").then((m) => m.GamesPageModule),
  },
  {
    path: "store",
    redirectTo: "mainTabs/tabs/store",
    pathMatch: "full",
  },
  {
    path: "store",
    loadChildren: () => import("./pages/store/store.module").then((m) => m.StorePageModule),
    data: { preload: true, delay: true, priority: 3 },
    canActivate: [AuthGuard],
  },
  {
    path: "private-syndicate",
    loadChildren: () =>
      import("./pages/private-syndicate/private-syndicate.module").then((m) => m.PrivateSyndicateModule),
  },
  {
    path: "checkWinnings",
    canActivate: [AuthGuard],
    loadChildren: () => import("./pages/check-winnings/check-winnings.module").then((m) => m.CheckWinningsModule),
  },
  {
    path: "cashout",
    canActivate: [AuthGuard],
    loadChildren: () => import("./pages/cashout/cashout.module").then((m) => m.CashoutModule),
  },
  {
    path: "charity-page",
    component: CharityPageComponent,
  },
  {
    path: "holdingScreen",
    component: HoldingScreenComponent,
  },
  {
    path: "product-not-available",
    loadChildren: () =>
      import("./product-not-available/product-not-available.module").then((m) => m.ProductNotAvailablePageModule),
  },
  { path: "setupCompleted", component: SetupCompleteComponent },
  {
    path: "account-created",
    component: AccountCreatedComponent,
    canActivate: [AngularFireAuthGuard],
    canDeactivate: [salesGuard],
  },
  {
    path: "pre-auth",
    component: PreAuthpageComponent,
    canActivate: [AngularFireAuthGuard],
  },
  {
    path: "voucherRedeemed",
    component: VoucherRedeemComponent,
  },
  {
    path: "successful-payment",
    component: SuccessfulPaymentComponent,
    canActivate: [AngularFireAuthGuard],
  },
  { path: "setupCompleted", component: SetupCompleteComponent },
  {
    path: "voucher",
    canActivate: [AuthGuard],
    component: VouchersComponent,
  },
  {
    path: "account",
    canActivate: [CampaignGuard],
    loadChildren: () => import("./pages/account/account.module").then((m) => m.AccountModule),
  },
  {
    path: "game",
    redirectTo: "mainTabs/tabs/game",
    pathMatch: "full",
  },
  {
    path: "game",
    loadChildren: () => import("./pages/games-feed-sample/games-feed.module").then((m) => m.GamesFeedModule),
  },
  {
    path: "subscription-settings",
    canActivate: [AngularFireAuthGuard, AuthGuard],
    component: SubscriptionSettingsComponent,
  },
  {
    path: "close-your-account",
    component: CloseConfirmationComponent,
  },
  {
    path: "delete-your-account",
    component: DeleteConfirmationComponent,
  },
  {
    path: "request-data",
    component: ReqDataComponent,
  },
  {
    path: "r",
    component: RedirectUriComponent,
  },
  {
    component: QuickLaunchComponent,
    path: "quick-launch",
  },
  {
    path: 'offline-waiting',
    component: OfflineWaitingComponent
  },
  {
    path: "games",
    redirectTo: "mainTabs/tabs/game",
    pathMatch: "full",
  },
  {
    path: "games",
    loadChildren: () => import("./pages/games-feed-sample/games-feed.module").then((m) => m.GamesFeedModule),
    data: { preload: true, delay: true, priority: 2 },
  },
  {
    path: "slidermanager",
    component: SliderManagerComponent,
  },
  {
    path: "prosub_page",
    component: ProsubPageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "suggestions",
    component: SuggestionComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "survey-return",
    component: SurveyReturnComponent,
  },
  {
    path: "partner-offer",
    component: PartnerOfferComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "custom-offer",
    component: PickOfferComponent,
    canActivate: [AngularFireAuthGuard, AuthGuard],
  },
  {
    path: "social",
    redirectTo: "mainTabs/tabs/social",
    pathMatch: "full",
  },
  {
    path: "takeover",
    component: TakeoverPageComponent,
  }, 
  {
    path: "registration-pending",
    component: RegisterPendingComponent,
  },
  {
    path: "event/:eventName",
    redirectTo: "welcome",
    pathMatch: "full",
  },



  // Add new routes before this path.
  // These module should be called last as we are using path as empty and no pathMatch full.
  {
    path: "",
    loadChildren: () => import("./pages/sales/sales.module").then((m) => m.SalesModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: CustomPreloadingStrategy })],
  exports: [RouterModule],
  providers: [CustomPreloadingStrategy],
})
export class AppRoutingModule { }


